export const SMART_HOME_APP_NAME = 'PORTAL';

export const ADDRESS_USAGE_SHIPPING = 'Shipping';
export const ADDRESS_USAGE_BILLING = 'Billing';
export const STRING_BILLING = 'billing';
export const STRING_ACCOUNT = 'account';

export enum QueryParamName {
  ReferrerCode = 'RCO',
  TestGroup = 'testID',
  AgentId = 'a_id',
  SaleSessionId = 'ss_id',
  StoreCode = 's_c',
  VendorData = 'v_data',
  CampaignId = 'cid',
  AccountId = 'accountId',
  SourceApp = 'sourceApp',
  CommunicationId = 'communicationId',
}

export enum CookieName {
  ReferrerCode = 'RC_RC',
  TestGroup = 'sh_testGroup',
  AgentId = 'a_id',
  SaleSessionId = 'ss_id',
  StoreCode = 's_c',
  VendorData = 'v_data',
  CampaignId = 'c_id',
  AccountId = 'acc_id',
  OpenedLinkForExpert = 'OpenedLinkForExpert',
  SourceApp = 'sourceApp',
  CommunicationId = 'communicationId',
}

export const YES = 'Yes';
export const NO = 'No';

export const SHS_PRICE = 20.0;

export const RESIDENCE_PAGE_NUMBER = 1;
export const BILLING_PAGE_NUMBER = 2;
export const REVIEW_PAGE_NUMBER = 4;

export const PATHS = {
  signup: 'signup',
  auth: 'user',
};

export const ctaProps = {
  to: '/signup/1',
  className: 'call-to-action',
};

export const FULL_STORY_FILTER_CLASS = 'full-story-filter';

export const DEVICES_STORAGE_KEY = 'pre_login_added_devices';

export const TERMS_OF_USE_URL = 'https://www.asurion.com/terms-conditions/';
export const PRIVACY_POLICY_URL = 'https://www.asurion.com/privacy-policy/';

export const TEST_GROUP_LOCALSTORAGE_KEY = 'test_groups';
export const TEST_GROUP_LOCALSTORAGE_DELETE_KEY = 'test_groups_delete';

export enum PageId {
  AddDevices = 'AddDevices',
  AgentSignup = 'AgentSignup',
  Dashboard = 'Dashboard',
  ExpertSessions = 'ExpertSessions',
  FAQ = 'FAQ',
  Homepage = 'Homepage',
  Login = 'Login',
  Logout = 'Logout',
  NotFound = 'NotFound',
  Profile = 'Profile',
  Signup = 'Signup',
  SignupUga = 'SignupUga',
  TermsAndConditions = 'TermsAndConditions',
  ValueCalcRedirect = 'ValueCalcRedirect',
  VerifySecretCode = 'VerifySecretCode',
  Welcome = 'Welcome',
  WhatsCovered = 'WhatsCovered',
  RefundWarranties = 'RefundWarranties',
  RefundGuide = 'RefundGuide',
  FeesAndDeductibles = 'FeesAndDeductibles',
}

export enum LinkId {
  HeaderMenuHome = 'header-menu-home',
  HeaderMenuWhatsCovered = 'header-menu-whats-covered',
  HeaderMenuClaims = 'header-menu-claims',
  HeaderMenuExpertSessions = 'header-menu-expert-sessions',
  HeaderMenuDashboard = 'header-menu-dashboard',
  HeaderMenuLogin = 'header-menu-login',
  HeaderMenuLogout = 'header-menu-logout',
  HeaderMenuFaq = 'header-menu-faq',
  HeaderMenuHelpNumber = 'header-menu-help-number',
  HeaderMenuChat = 'header-menu-chat',
  FooterMenuHome = 'footer-menu-home',
  FooterMenuWhatsCovered = 'footer-menu-whats-covered',
  FooterMenuClaims = 'footer-menu-claims',
  FooterMenuExpertSessions = 'footer-menu-expert-sessions',
  FooterMenuDashboard = 'footer-menu-dashboard',
  FooterMenuLogin = 'footer-menu-login',
  FooterMenuLogout = 'footer-menu-logout',
  FooterMenuFaq = 'footer-menu-faq',
  FooterMenuHelpNumber = 'footer-menu-help-number',
  FooterMenuChat = 'footer-menu-chat',
  FooterMenuTermsConditions = 'footer-menu-terms-conditions',
  FooterMenuTermsOfUse = 'footer-menu-terms-of-use',
  FooterMenuPrivacyPolicy = 'footer-menu-privacy-policy',
  AuthForgotPassword = 'auth-forgot-password',
  AuthResendSecretCode = 'auth-resend-secret-code',
  AuthVerifySecretGoBack = 'auth-verify-secret-go-back',
  AuthTermsOfUse = 'auth-terms-of-use',
  AuthPrivacyPolicy = 'auth-privacy-policy',
  DashboardDevicesViewDevice = 'dashboard-devices-view-device',
  DashboardDevicesAddDevice = 'dashboard-devices-add-device',
  DashboardHomeActionChat = 'dashboard-home-action-chat',
  DashboardHomeActionCall = 'dashboard-home-action-call',
  DashboardHomeActionFaq = 'dashboard-home-action-faq',
  DashboardHomeActionClaim = 'dashboard-home-action-claim',
  DashboardHomeActionWhatsCovered = 'dashboard-home-action-whats-covered',
  DashboardHomeActionSeeWhatsCovered = 'dashboard-home-action-see-whats-covered',
  DashboardHomeActionShowMeRefundWarranties = 'dashboard-home-action-show-me-refund-warranties',
  DashboardHomeSupportChat = 'dashboard-home-support-chat',
  DashboardHomeSupportSupport = 'dashboard-home-support-support',
  DashboardHomeSupportAdvice = 'dashboard-home-support-advice',
  DashboardHomeSupportExpertSessions = 'dashboard-home-support-expert-sessions',
  DashboardDeviceViewChat = 'dashboard-device-view-chat',
  DashboardDeviceViewCall = 'dashboard-device-view-call',
  DashboardGetHelpChat = 'dashboard-get-help-chat',
  DashboardGetHelpCall = 'dashboard-get-help-call',
  RefundSelectionNeedHelpCall = 'refund-selection-need-help-call',
  DashboardHomeActionShowMeRefundGuide = 'refund-guide',
  WhatsCoveredNeedHelpCall = 'whats-covered-need-help-call',
  FeesAndDeductiblesNeedHelpCall = 'fees-and-deductibles-need-help-call',
  RefundGuideNeedHelpCall = 'refund-guide-need-help-call',
  RefundSelectionContinue = 'refund-selection-continue-button',
  WhatsCoveredSeeFees = 'whats-covered-see-fees-button',
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/constants.ts